import React from "react";
import {TextField} from "@mui/material";
import {useFormContext} from "react-hook-form";

import {useLxTranslations} from "@lxo-blocks/react";
import {MFARESET_FORM_TRANSLATION} from "./MfaResetForm.translation.de";

export const MfaResetCodeFormInput = React.forwardRef<any, any>((props, ref) => {
    const {t} = useLxTranslations(MFARESET_FORM_TRANSLATION);
    const {errors} = useFormContext();
    return (
        <TextField
            {...props}
            ref={ref}
            fullWidth
            label={t("RESETCODE")}
            inputProps={{
                "aria-label": "Code",
                autoComplete: 'off'
            }}
            error={!!errors.mfarecoverycode}
            helperText={
                errors.mfarecoverycode?.message
            }
            variant="outlined"
        />
    );
});
